// import { register } from '@/module/Register/locale/register.th.js';
import { example } from '@/module/Example/locale/example.th';
// base
import { date } from '@/helper/locale/base/base_date.th.js';
import { button } from '@/helper/locale/base/base_button.th.js';
// module
import { collect_point } from '@/module/CollectPoint/locale/collectpoint.th.js';
import { home } from '@/module/Home/locale/home.th.js';
import { profile } from '@/module/Profile/locale/profile.th.js';
import { mission } from '@/module/Mission/locale/mission.th.js';
import { financial_health } from '@/module/FinancialHealth/locale/financial_health.th.js';

export const th = {
    example: example,
    // base
    date: date,
    button: button,
    // module
    collect_point: collect_point,

    home: home,
    profile: profile,
    mission: mission,
    financial_health: financial_health,

    confirm_redeem: {
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",

        headline: 'ยืนยัน',
        default: 'ยืนยันการแลกรับสิทธิ',
        defualt_have_time: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'ยืนยันการรับสิทธิ์',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'ยืนยันการรับสิทธิ์',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันการรับสิทธิ์',

        msg_free_deal: 'ต้องการใช้ {0} แพลงก์ตอน<br/>เพื่อแลกรับสิทธิใช่หรือไม่',
        msg_interface: 'ต้องการใช้ {0} แพลงก์ตอน<br/>เพื่อแลกรับสิทธิใช่หรือไม่',

    },
    redeem_button: {
        default: 'แลกรับสิทธิ',
        none: '',
        soldOut: 'สิทธิพิเศษนี้ มีผู้รับสิทธิเต็มจำนวนแล้ว',
        soldOutBuy: 'สิทธิพิเศษนี้ มีผู้รับสิทธิเต็มจำนวนแล้ว',
        maxPerPerson: 'คุณได้รับสิทธิพิเศษนี้ครบตามจำนวนที่กำหนดแล้ว',
        redeemCoolDown: 'คุณได้กดรับสิทธินี้ไปแล้ว โปรดกดรับสิทธิใหม่อีกครั้งภายหลัง',
        nextDate: 'รับสิทธิ์ครั้งต่อไปได้<br/>ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'คุณต้องทำตามเงื่อนไขของแคมเปญนี้ก่อนจึงสามารถกดรับสิทธิ์ได้',
        campaignExpired: 'สิทธิพิเศษนี้หมดอายุแล้ว',
        campaignExpiredBuy: 'สิทธิพิเศษนี้หมดอายุแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'คุณมีแพลงก์ตอนไม่พอ',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้'
    },
    purchase: {
        show_code: 'กดเพื่อดูรหัส',
        code_expired: 'หมดอายุ',
        code_used: 'ใช้สิทธิ์แล้ว',

        delivery: 'กำลังจัดส่ง',
        shipped: 'จัดส่งสำเร็จแล้ว',
        parcel_no: 'เลขพัสดุ',

        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',

        status: 'สถานะ : ',
        used_coupon: 'ดูคูปอง',
        use_date: 'ใช้งานได้ถึง',

        status_process: {
            prepare: 'เตรียมจัดส่ง',
            on_delivery: 'อยู่ระหว่างจัดส่ง',
            delivery: 'กำลังจัดส่ง',
            success: 'จัดส่งสำเร็จ',
        }
    },
    serial: {
        close_btn: 'ปิด',
        default_privilege_message: 'ตามดีไซน์',
        show_code_at_shop: 'กรุณาแสดงรหัสนี้ ให้แก่ร้านค้า',
        title_for_staff: 'สำหรับร้านค้าเท่านั้น',
        btn_for_staff: 'สำหรับพนักงาน',

        // delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',
        delivery: {
            title: 'แลกรับสิทธิแล้ว',
            msg: 'สินค้าจะจัดส่งภายใน 3-5 วันทำการ',
            btn_coupon: 'ดูสิทธิพิเศษของฉัน',
            btn_close: 'ปิด'
        },

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'คิวอาร์ โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'โค้ด',

        copy_code: 'คัดลอกรหัส',
        copy_success: 'คัดลอกแล้ว',

        expire_in: 'หมดอายุ : ',
        minute: 'นาที',
        code_expired: 'รหัสหมดอายุ',
        date_redeem: 'วันที่แลกรางวัล :',

        redeem_on: 'รับสิทธิ์เมื่อ {0}',

        detail: 'รายละเอียดสิทธิพิเศษ',
        btn_coupon: 'ดูสิทธิพิเศษของฉัน',
        btn_close: 'ปิด',
        camp_expire: 'สิทธิพิเศษหมดอายุ',
        camp_used: 'ใช้สิทธิแล้ว',
    },
    shipping: {
        headline: 'ที่อยู่เพื่อจัดส่ง',
        info_warning: 'ลูกค้าจะต้องเป็นผู้กรอกรายละเอียดการจัดส่งด้วยตนเองและธนาคารขออนุญาตส่งข้อมูลจัดส่งให้กับบริษัท 3rd party',

        firstname: {
            name: 'ชื่อ',
            placeholder: 'โปรดกรอกชื่อ',
            required: 'โปรดกรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'โปรดกรอกนามสกุล',
            required: 'โปรดกรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        addressName: {
            name: 'ชื่อที่อยู่',
            placeholder: 'ชื่อที่อยู่',
            required: 'กรุณากรอกชื่อที่อยู่',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'รายละเอียด (บ้านเลขที่ หมู่บ้าน ถนน ฯลฯ)',
            placeholder: 'กรอกที่อยู่',
            required: 'กรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'เบอร์โทรศัพท์',
            placeholder: 'โปรดกรอกเบอร์โทรศัพท์',
            required: 'โปรดกรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'โปรดกรอกรหัสไปรษณีย์',
            required: 'โปรดกรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'แขวง / ตำบล',
            placeholder: 'โปรดเลือกแขวง / ตำบล',
            required: 'โปรดเลือกแขวง / ตำบล',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'เขต / อำเภอ',
            placeholder: 'โปรดเลือกเขต / อำเภอ',
            required: 'โปรดเลือกเขต / อำเภอ',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'โปรดเลือกจังหวัด',
            required: 'โปรดเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        isDefaultAddress: 'บันทึกที่อยู่นี้ในการจัดส่ง',
        defaultAddress: 'ที่อยู่หลัก',
        save_address: 'บันทึกที่อยู่เพื่อใช้รับสิทธิ์ครั้งต่อไป',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',

        modal_confirm: {
            title: 'โปรดตรวจสอบข้อมูลให้ถูกต้อง',
            msg: 'ยืนยันการตรวจสอบข้อมูล',
            btn_edit: 'แก้ไข',
        }
    },
    tax: {
        personType: {
            name: 'ออกในนาม',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        title: {
            name: 'คำนำหน้าชื่อ',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        companyName: {
            name: 'ชื่อ / บริษัท',
            placeholder: 'ชื่อ / บริษัท',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        building: {
            name: 'อาคาร',
            placeholder: 'อาคาร',
            required: '',
            too_short: '',
            invalid: '',
        },
        room: {
            name: 'เลขที่ห้อง',
            placeholder: 'เลขที่ห้อง',
            required: '',
            too_short: '',
            invalid: '',
        },
        floor: {
            name: 'ชั้นที่',
            placeholder: 'ชั้นที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        village: {
            name: 'หมู่บ้าน',
            placeholder: 'หมู่บ้าน',
            required: '',
            too_short: '',
            invalid: '',
        },
        number: {
            name: 'เลขที่',
            placeholder: 'เลขที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        moo: {
            name: 'หมู่ที่',
            placeholder: 'หมู่ที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        soi: {
            name: 'ซอย',
            placeholder: 'ซอย',
            required: '',
            too_short: '',
            invalid: '',
        },
        road: {
            name: 'ถนน',
            placeholder: 'ถนน',
            required: '',
            too_short: '',
            invalid: '',
        },
    },
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        category: 'หมวดหมู่',
        map: "แผนที่",
        terms: "Terms And Conditions",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",
    },
    campaign: {
        point: 'แพลงก์ตอน',
        get_point: 'ได้ ',
        use_point: 'ใช้ ',
    },
    detail: {
        detail: 'รายละเอียด',
        condition: 'เงื่อนไข',

        point_unit: 'แพลงก์ตอน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้',
        available_date: 'แลกได้วันที่',
        expire_date: 'วันหมดอายุ : {0}',

        color: {
            name: 'สี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'ขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },

        verify: {
            title: 'กรอกรหัสยืนยัน',
            msg: 'โปรดกรอกรหัสยืนยันเพื่อใช้ {0} แพลงก์ตอน ในการรับสิทธิ',
            verify_code: {
                name: '',
                placeholder: 'กรอกรหัสที่นี่',
                required: '',
                too_short: '',
                invalid: 'รหัสไม่ถูกต้อง โปรดตรวจสอบรหัสของคุณอีกครั้ง',
                use_expire: 'รหัสนี้ถูกใช้แล้ว/หมดอายุ'
            },
            btn_confirm: 'ยืนยัน'
        }
    },
    history: {
        point: 'แพลงก์ตอน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        date_get_point: 'วันที่ได้รับแพลงก์ตอน : ',
        date_use_point: 'วันที่ใช้แพลงก์ตอน : ',
        title_earn: 'ได้รับแพลงก์ตอน',

        parcel_number: 'เลขพัสดุ : ',
        copy: 'คัดลอก',

        monthPicker: {
            name: '',
            placeholder: '',
            required: 'กรุณาเลือกเดือน/ปี',
            too_short: '',
            invalid: '',
            month: {
                name: '',
                placeholder: 'เดือน',
                required: ' '
            },
            year: {
                name: '',
                placeholder: 'ปี',
                required: ' '
            },
        },
        menu: {
            coupon: 'สิทธิพิเศษ<br>ของฉัน',
            history_point: 'ประวัติ<br>แพลงก์ตอน',
            favourite: 'ถูกใจ',
            get_friend: 'แนะนำเพื่อน',
        },
        expire: 'หมดอายุ',
        delivery: {
            address: 'ที่อยู่ในการจัดส่ง : ',
            mobile_number: 'เบอร์โทร : ',
        },
        starbuck: {
            date_valid: 'Valid from Today - 16 June 2023',
            detail: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut.',
            btn_back: 'BACK',
            condition: '**   สามารถใช้ซื้อสินค้าประเภทใดก็ได้ในร้านสตาร์บัคส์ทุกสาขาในประเทศไทยเท่านั้น<br /> *** ไม่สามารถใช้เติมเงินใส่บัตรสาตาร์บัคส์การ์ดและลูกค้าจะไม่ได้รับสิทธิประโยชน์ของ My Starbucks Rewards  ไม่สามารถแลกเป็นเงินสดได้ ไม่สามารถใช้สิทธิ์ได้หากเป็นการทำสำเนา บริษัท สตาร์บัตส์คอฟฟี่ (ประเทศไทย) จำกัด<br /> *** ไม่สามารถใช้สิทธิ์จากคูปองรูปภาพที่ถูกคัดลอกในทุกกรณี',
            title: 'e-Coupon',
            price: 'Value {0} Baht',
            remark: '*for purchasing any product.',
        },
        mission: {
            fgf_invite: 'ชวนเพื่อนแล้ว',
            fgf_invite_unit: '',
            fgf_view_history: 'ดูประวัติ',
            fgf_code: 'รหัสแนะนำ',
        }
    },
    menubar: {
        home: 'สิทธิพิเศษ',
        mission: 'ภารกิจ',
        my: 'ฉัน',
    },
    not_found: 'ไม่พบข้อมูล',
    no_data: 'ไม่มีข้อมูล',
    loading: 'กำลังโหลด รอสักครู่นะ',
    no_internet: 'พบปัญหาการเชื่อมต่ออินเตอร์เน็ต โปรดลองใหม่อีกครั้งภายหลัง<br>ไม่สามารถให้บริการได้ชั่วคราว ขออภัยในความไม่สะดวก',
    modal: {
        register: {
            title: 'ลงทะเบียนสำเร็จ',
            msg: 'ได้รับรหัสเรียบร้อยแล้ว',
        },
        redeemed: {
            title: 'แลกรับสิทธิแล้ว',
            msg: 'ยินดีด้วยคุณได้รับสิทธิ์ Viu ดูหนังฟรี 1 เดือน',
            btn: 'ตกลง',
        },
        point: {
            title: 'แลกรับสิทธิแล้ว',
            title_fgf: 'กรอกรหัสสำเร็จแล้ว',
            msg: 'เย่! คุณได้รับ {0} แพลงก์ตอน',
        },
        getfriend: {
            title: 'ยินดีด้วย',
            msg: 'คุณได้รับ {0} แพลงก์ตอนจากการกรอกรหัส<br>สำหรับแนะนำเพื่อนตกลง',
        },
        err_code: {
            title: 'รหัสไม่ถูกต้อง',
            msg: 'โปรดตรวจสอบรหัสของคุณอีกครั้ง',
        },
        btn: 'ตกลง'
    },
    token_expire: {
        title: 'โปรดลองใหม่อีกครั้งภายหลัง',
        msg: 'โปรดลองใหม่อีกครั้งภายหลัง',
        btn: 'ปิด',
    },
    page_not_found: 'ไม่พบ URL บนเว็บของเรา',
    under_construction: 'ไม่สามารถให้บริการได้ชั่วคราว ขออภัยในความไม่สะดวก',
    coming_soon: 'พบกันเร็วๆ นี้',
    getfriend: {
        title: 'ประวัติการชวนเพื่อน',
        item_msg: 'เดือนนี้ชวนเพื่อนแล้ว',
        unit_count: 'คน',
        no_data: "คุณยังไม่ได้ชวนเพื่อนในเดือนนี้",
    },
    golden_question: {
        welcome: {
            title: 'คุณเป็นนากช่างสงสัย<br>เหมียวนักผจญภัย<br>หรือเพนกวินรักสงบ',
            message: 'ใช้เวลาเพียง 2 นาที<br>ในการทำแบบทดสอบเพื่อหาตัวตนของคุณ',
            start: 'เริ่มเลย',
            exit: 'ออก',
        },
        question: {
            header: 'ลองดูซิว่าเจ้าตัวไหนที่ตรงกับตัวคุณ',
            from: 'จาก',
            description: 'คุณเห็นด้วยกับข้อความนี้แค่ไหน โปรดระบุคะแนน',
            strongly_disagree: '1 - ไม่เห็นด้วยอย่างยิ่ง',
            strongly_agree: '7 - เห็นด้วยอย่างยิ่ง',
            back: 'ย้อนกลับ',
            next: 'ถัดไป',
            result: 'ดูผล'
        },
        result: {
            you_are: 'คุณคือ',
            animal: {
                otter: 'นากช่างสงสัย',
                cat: 'เหมียวนักผจญภัย',
                corgi: 'คอร์กี้จอมมุ่งมั่น',
                tiger: 'เสือจอมวางแผน',
                bee: 'ผึ้งจอมอึด',
                penguin: 'เพนกวินรักสงบ'
            },
            you_are_in_group: 'คุณอยู่ในกลุ่มนี้',
            see_plankton: 'ได้รับ 50 แพลงก์ตอนแล้ว ดูเลย',
            you_get_plankton: 'ได้รับแพลงก์ตอนแล้ว'
        }
    }
};
